import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function PublicServiceCategoryPage({ category, onBack }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");

  const categoryConfig = {
    temples: {
      title: "Temples",
      eyebrow: "PLACES OF WORSHIP",
      description:
        "Temples and places of worship in and around Vijayanagar.",
      keywords: ["temple", "temples", "mandir"],
    },

    hospitals: {
      title: "Hospitals",
      eyebrow: "HEALTHCARE",
      description:
        "Hospitals and healthcare facilities available to residents.",
      keywords: ["hospital", "hospitals", "healthcare", "medical"],
    },

    "police-stations": {
      title: "Police Stations",
      eyebrow: "PUBLIC SAFETY",
      description:
        "Police stations and local public safety information.",
      keywords: ["police", "police station", "police stations"],
    },

    libraries: {
      title: "Libraries",
      eyebrow: "LEARNING & READING",
      description:
        "Libraries and public learning resources in the area.",
      keywords: ["library", "libraries"],
    },

    schools: {
      title: "Schools",
      eyebrow: "EDUCATION",
      description:
        "Schools and public education-related information.",
      keywords: ["school", "schools", "education"],
    },
  };

  const config =
    categoryConfig[category] || categoryConfig.temples;

  useEffect(() => {
    setLoading(true);

    api.get("/services")
      .then((r) => {
        const all = r.data.items || r.data || [];

        const filtered = all.filter((item) => {
          const itemCategory = String(item.category || "")
            .toLowerCase()
            .trim();

          if (itemCategory === category) return true;

          const text = [
            item.name,
            item.title,
            item.description,
            item.category,
            item.type,
            item.service_type,
          ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();

          return config.keywords.some((keyword) =>
            text.includes(keyword)
          );
        });

        setItems(filtered);
      })
      .catch(() => {
        setItems([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [category]);

  const filteredItems = items.filter((item) => {
    const q = query.trim().toLowerCase();

    if (!q) return true;

    return [
      item.name,
      item.title,
      item.address,
      item.phone,
      item.hours,
      item.category,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(q);
  });

  return (
    <SimplePage title={config.title} onBack={onBack}>
      <div className="service-directory-modern">

        <section className="service-directory-hero">
          <div>
            <span className="eyebrow">{config.eyebrow}</span>

            <h2>{config.title}</h2>

            <p>{config.description}</p>
          </div>

          <div className="service-directory-count">
            <strong>{items.length}</strong>
            <span>
              {items.length === 1 ? "listing" : "listings"}
            </span>
          </div>
        </section>

        <div className="service-directory-toolbar">
          <div className="service-search">
            <Search size={18} />
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={`Search ${config.title.toLowerCase()}...`}
              aria-label={`Search ${config.title}`}
            />
          </div>

          <span className="service-result-count">
            {loading
              ? "Loading..."
              : `${filteredItems.length} result${filteredItems.length === 1 ? "" : "s"}`}
          </span>
        </div>

        {loading ? (
          <div className="services-loading-grid">
            {[1, 2, 3].map((n) => (
              <div className="service-skeleton" key={n}>
                <div />
                <div />
                <div />
              </div>
            ))}
          </div>
        ) : filteredItems.length === 0 ? (
          <div className="service-empty-state">
            <div className="service-empty-icon">
              <Building2 size={30} />
            </div>

            <h3>
              {query
                ? "No matching listings"
                : `No ${config.title.toLowerCase()} listed yet`}
            </h3>

            <p>
              {query
                ? "Try a different search term."
                : "Public listings for this category will appear here when they are added through the administration dashboard."}
            </p>

            {query && (
              <button
                type="button"
                className="civic-btn secondary"
                onClick={() => setQuery("")}
              >
                Clear Search
              </button>
            )}
          </div>
        ) : (
          <div className="service-list-modern">
            {filteredItems.map((item, index) => {
              const name = item.name || item.title || "Public Service";

              return (
                <article
                  className="service-place-card"
                  key={item.id || `${name}-${index}`}
                >
                  <div className="service-place-icon">
                    {category === "police-stations" ? (
                      <ShieldCheck size={23} />
                    ) : (
                      <Building2 size={23} />
                    )}
                  </div>

                  <div className="service-place-main">
                    <div className="service-place-heading">
                      <div>
                        <span className="service-place-label">
                          {config.title}
                        </span>
                        <h3>{name}</h3>
                      </div>
                    </div>

                    <div className="service-place-details">
                      {item.address && (
                        <div>
                          <MapPin size={16} />
                          <span>{item.address}</span>
                        </div>
                      )}

                      {item.phone && (
                        <div>
                          <Phone size={16} />
                          <span>{item.phone}</span>
                        </div>
                      )}

                      {item.hours && (
                        <div>
                          <Clock3 size={16} />
                          <span>{item.hours}</span>
                        </div>
                      )}
                    </div>

                    <div className="service-place-actions">
                      {item.phone && (
                        <a
                          href={`tel:${String(item.phone).replace(/\s+/g, "")}`}
                          className="service-action"
                        >
                          <Phone size={15} />
                          Call
                        </a>
                      )}

                      {item.address && (
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.address)}`}
                          target="_blank"
                          rel="noreferrer"
                          className="service-action secondary"
                        >
                          <MapPin size={15} />
                          Directions
                        </a>
                      )}
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        )}

      </div>
    </SimplePage>
  );
}




function ServiceCategoryPage(props) { return <PublicServiceCategoryPage {...props} />; }
export default ServiceCategoryPage;
